/**
 * 通用接口
 */
import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  accountSetting: data => axios({ baseURL, url: '/api/store/accountSetting', method: 'POST', data }), // 平台下拉框数据
  getVerificationCode: data => axios({ baseURL, url: `/api/store/authentication`, method: 'POST', data }), // 发送邮箱验证码
  verificationUser: data => axios({ baseURL, url: `/api/store/authenticationCheck`, method: 'POST', data }), // 验证用户
  getUserPlatform: () => axios({ baseURL, url: `/api/store/userPlatform` }), // 用户店铺所对应的平台下拉
  getEmailStatus: () => axios({ baseURL, url: `/api/store/authenticationByUserId` }), // 获取用户邮箱是否已认证
  getCurrencyRate: params => axios({ baseURL, url: `/api/system/open/currencyRate`, method: 'get', params }), // 获取币种之间汇率
  getUserBehavior: params => axios({ baseURL, url: `/api/store/userBehavior`, method: 'get', params }), // 获取用户行为信息
  setUserBehavior: data => axios({ baseURL, url: `/api/store/userBehavior`, method: 'put', data }), // 编辑用户行为信息

  getPaymentTransaction: paymentId => axios({ baseURL, url: `/api/payment/transaction/${paymentId}`, method: 'get' }) // 获取单个订单 (获取订单以及商品信息)

}
